import 'core-js';

import 'expose-loader?exposes=$,jQuery!jquery';
import 'script-loader!bootstrap-toggle';
import 'jquery-ui-dist/jquery-ui';
import 'jquery-validation/dist/jquery.validate'
import 'jquery-validation/dist/additional-methods'
import 'script-loader!timepicker/jquery.timepicker';
import 'bootstrap';
import 'eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min';
import 'script-loader!bootstrap-multiselect/dist/js/bootstrap-multiselect.js';
import 'expose-loader?exposes=moment!moment';
import 'expose-loader?exposes=Pickr!@simonwep/pickr/dist/pickr.min';
import 'expose-loader?exposes=dragula!dragula/dist/dragula';
import Modernizr from 'modernizr';

window.Modernizr = Modernizr;
import select2 from 'select2';

select2($);
$.fn.select2.defaults.set("theme", "bootstrap");
import {flashy} from "./src/utils/toastFunctions";

window.flashy = flashy;